/**
 * 本地接口代理
 */

const unitePre = '/boss';
// const unitePre = '';

const envList = ['dev', 'sit', 'product'];

const system = [
  {
    name: '灵格低代码平台',
    appId: '100001',
  },
];

const proxyList = [
  {
    target: 'http://api.linggekj.com/',
    // target: 'http://api-linggekj.com/', // 不用写死，统一走 {env} 占位符
    sysList: [
      '/infra-certificate',
      '/infra-integration',
      '/infra-authority',
      '/infra-message',
      '/demo-lowcode',
      '/infra-metadata',
      '/infra-workflow',
      '/infra-impexp',
      '/infra-sign',
      '/infra-ruleengine',
      '/lingbo-crm',
      '/lingbo-funds',
      '/lingbo-data',
      '/lingbo-console'
    ],
  },
  // 可以继续添加更多配置 ...
];

const getProxy = () => {
  const data = {};

  envList.forEach((env) => {
    proxyList.forEach((p) => {
      p.sysList.forEach((sys) => {
        const curKey = `${unitePre}${sys}`;

        // 判断 target
        let curTarget;
        // if (env === 'product') {
        //   curTarget = 'http://api.linggekj.com/';
        // } else {
        //   curTarget = p.target.replace('{env}', env);
        // }
        //  curTarget = 'http://lingbo-api-dev.linggekj.com/';
         curTarget = 'http://api.linggekj.com/';
        const rule = `^${curKey}`;

        // 特殊情况 pathRewrite 规则
        if (['/dev-carrier', '/legacy-finance-collection'].includes(sys)) {
          data[curKey] = {
            target: curTarget,
            secure: false,
            logLevel: 'debug',
            pathRewrite: {
              [rule]: '',
            },
          };
        } else {
          data[curKey] = {
            target: curTarget,
            secure: false,
            logLevel: 'debug',
            pathRewrite: {
              [rule]: sys,
            },
          };
        }
      });
    });
  });

  return data;
};

const proxyConfig = {
  ...getProxy(),
};

module.exports = {
  proxyConfig,
  envList,
  system,
};
